"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Check = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 15 11"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.gray,
  fillRule: "evenodd",
  d: "M13.828.707a1 1 0 010 1.414l-8.485 8.486-.015-.015c-.39.275-.934.238-1.283-.11l-3.64-3.63A.999.999 0 01.32 5.535l.085-.097a1 1 0 011.413 0l2.937 2.927 7.66-7.658a1 1 0 011.413 0z"
}));

var _default = Check;
exports.default = _default;